import React, { useState } from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Divider,
  Tabs,
  Input,
  Button,
} from "antd";
import type { TabsProps } from "antd";
import styles from "./KnowledgeHub.module.scss";
import { TabInfo } from "./TabInfo";
import { Title } from "../Title/Title";
import { useNavigate } from "react-router-dom";

export const KnowledgeHub = () => {
  const [input, seInput] = useState("");
  const navigate = useNavigate();
  return (
    <>
      <div
        className="knowledge-hub"
        style={{ background: "#003087", paddingTop: 60 }}
      >
        <Row>
          <Col lg={2} sm={24}></Col>
          <Col lg={22} sm={24}>
            <Row>
              <Col span={21}>
                <Title title="DECARBONIZATION KNOWLEDGE HUB" width={1300} />
              </Col>
            </Row>
            <div style={{ display: "flex" }}>
              <div style={{ paddingTop: 0, width: "100%" }}>
                <div>
                  <Typography.Title level={4} style={{ color: styles.white }}>
                    Hello, What can we Help you Find
                  </Typography.Title>
                </div>
                <div style={{ marginTop: 20, marginRight: 180 }}>
                  <div style={{ display: "flex" }}>
                    <Input
                      placeholder="Ask AI to find anything"
                      onChange={(e) => seInput(e.target.value)}
                      style={{ height: 50 }}
                    />
                    <Button
                      type="primary"
                      className="btn-primary"
                      style={{
                        height: 50,
                        borderRadius: "24 !important",
                        marginLeft: -50,
                        minWidth: 100,
                      }}
                      onClick={() => {
                        if (input) {
                          localStorage.setItem("selectedFAQ", input);
                          navigate(`/knowledge-hub?q=${input}`);
                        }
                      }}
                    >
                      ASK
                    </Button>
                  </div>
                  <Typography.Title
                    level={4}
                    style={{
                      color: styles.white,
                      marginTop: 40,
                      marginBottom: 0,
                    }}
                  >
                    Frequently asked questions
                  </Typography.Title>
                </div>
                <TabInfo />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
